import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ContractsModelService} from '../../../Models/Rrhh/Contracts/contracts-model.service';
import {ContractsTypesModelService} from '../../../Models/Rrhh/Contracts/contracts-types-model.service';
import {EndReasonsModelService} from '../../../Models/Rrhh/Contracts/end-reasons-model.service';

@Injectable({
  providedIn: 'root'
})
export class ContractsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ContractsModelService,
    public modelTypes: ContractsTypesModelService,
    public modelEndReasons: EndReasonsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los contratos
   *
   */
  public getContracts(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getContracts', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los tipos de contratos
   *
   */
  public getContractsTypes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('contracts/types', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelTypes.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Recuperar los tipos de baja
   *
   */
  public getEndReasons(save: boolean = true): Promise<ApiResponse> {
    return new Promise((resolve, reject) => {
      return this.httpCall('contracts/end_reasons', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelEndReasons.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });
    });
  }

}
